import { ApolloError, ApolloQueryResult, DocumentNode } from '@apollo/client';
import { TemplateId } from 'modules/domains/template';
import { useMemo } from 'react';
import { useGraphql } from 'utils/hooks/useGraphql';
import { queryTemplateAndContentById } from '../queries';
import { GraphQLTemplateAndContent } from '../types';

export type QueryTemplateAndContentByIdRequest = {
  id: TemplateId;
};

export type QueryTemplateAndContentByIdResponse = {
  campaign: GraphQLTemplateAndContent;
};

export type UseQueryTemplateAndContentByIdResponse = {
  errorMessage?: ApolloError;
  hasError: boolean;
  isLoading: boolean;
  refetch: (
    variables?: QueryTemplateAndContentByIdRequest,
  ) => Promise<ApolloQueryResult<QueryTemplateAndContentByIdResponse>>;
  results: GraphQLTemplateAndContent;
};

export const useQueryTemplateAndContentById = (
  options: Record<string, any> = {},
  query: DocumentNode = queryTemplateAndContentById,
): UseQueryTemplateAndContentByIdResponse => {
  const queryOptions = useMemo(
    () => ({
      notifyOnNetworkStatusChange: true,
      ...options,
    }),
    [options],
  );

  const {
    data,
    errorMessage,
    isLoading,
    error: hasError = false,
    refetch,
  } = useGraphql(query, queryOptions);

  const results = data?.templateAndSingleContent ?? {};

  return {
    errorMessage,
    hasError,
    isLoading,
    refetch,
    results,
  };
};
